import FlipboardWeb from "./Flipboard/FlipboardWeb";

function App() {
  return (
    <div>
      {/* <h1>hello friends</h1> */}
      <FlipboardWeb></FlipboardWeb>
    </div>
  );
}

export default App;
